import { action } from 'satcheljs';
import { PersonaPresence } from 'office-ui-fabric-react/lib/Persona';
import ChatSignInState from '../store/schema/ChatSignInState';

export const addOrUpdatePresence = action(
    'ADD_OR_UPDATE_PRESENCE',
    (sipUri: string, newPresence: PersonaPresence) => ({
        sipUri,
        newPresence,
    })
);

export const changeSignInState = action(
    'CHANGE_SIGN_IN_STATE',
    (newSignInState: ChatSignInState) => ({ newSignInState })
);
